import { Button, Image } from "antd";
import React from "react";
import Success from "../../../../assets/images/success.png";
import dinnerSuccess from "../../../../assets/images/Thank-You.png";
import dinnerSuccessText from "../../../../assets/images/section-text-success.png";
import { ArrowRightOutlined } from "@ant-design/icons";

export const EconnectSuccessSection: React.FC = (): React.ReactElement => {
  return (
    <>
      <div className="w-[353px] h-[653.18px] top-[99px] left-[25px] rounded-[10px] pt-[32px] pr-[26px] pb-[32px] pl-[26px] gap-[32px]">
        <div className=" flex justify-center">
          <Image src={Success} preview={false} />
        </div>
        <br />
        <br />
        <div className=" flex justify-center">
          <Image src={dinnerSuccess} preview={false} />
        </div>
        <br />
        <br />
        <div className=" flex justify-center">
          <Image src={dinnerSuccessText} preview={false} />
        </div>
        <br />
        <br />
        <Button
          onClick={() => (window.location.href = `https://econnect.osd.co.th/event/`)}
          type="primary"
          className="w-[301px] h-[49px] rounded-[15px] py-3 gap-2 flex justify-center bg-[rgba(10,78,136,1)] text-[rgba(255,255,255,1)]"
        >
          {`View Event Details`} <ArrowRightOutlined />
        </Button>
        <br />
      </div>
    </>
  );
};
